import toast from 'react-hot-toast';
import { apiConfig } from 'core-lib/config/config';
import { getMethod } from 'core-lib/utils/apiV2';
import { BankType } from '../types/Bank';
import { getDefaultHeaders } from 'core-lib/utils/network';

export function serialize(data: any) {
  return data?.map((el) => {
    const item: BankType = {
      id: el.id,
      bankId: el.bank_list_id,
      code: el.parkplus_bank_code,
      enable: el.is_active,
      displayName: el.display_name,
      icon: el.image_url,
      isDown: el.is_down,
      downMessage: el.down_message,
      paymentPartner: el?.payment_partner_code || null,
    };
    return item;
  });
}

type ResultTypes = {
  response?: BankType[];
  error?: any;
};

const fetchBankList = async (categoryId: number): Promise<ResultTypes> => {
  let url = `${apiConfig('payment', 'v1')}/payments/bank-list/`;

  if (categoryId) {
    url += `?category_id=${categoryId}`;
  }

  const headers = getDefaultHeaders({
    deviceOs: true,
    deviceId: true,
    effectivePlatform: true,
    nativeAppVersion: false,
  });
  const { response, error }: any = await getMethod({ endPoint: url, headers });
  if (response) {
    if (response?.data?.bank_list) {
      return { response: serialize(response.data.bank_list) };
    } else return { error: {} };
  }
  if (error) {
    return { error };
    toast.error('Unable to fetch bank list');
  }
};

export default fetchBankList;
